import React from 'react';
import { appStore } from '../store';
import { App } from './App';
import { navigateTo } from '../navutils';

export class AppContainer extends React.PureComponent {
  constructor(props) {
    super(props);

    appStore.on('loaded-natives', () => {
      navigateTo(window.location.hash || window.location.search, true);
    });

    this.nativeRefs = {};

    this.listener = (ev) => {
      navigateTo(window.location.hash || window.location.search);
    };

    this.stateListener = (ev) => {
      navigateTo(ev.state.hash, false, true);
    };

    this.keyListener = (ev) => {
      if (ev.key === 'ArrowUp' || ev.key === 'ArrowDown') {
        const delta = (ev.key === 'ArrowUp') ? -1 : 1;

        const list = appStore.viewNativeList.natives;

        const curSelection = appStore.selection.curIndex || 0;
        const nextSelection = curSelection + delta;
        const finalSelection = (nextSelection < 0) ?
          list.length - 1 :
          (nextSelection >= list.length) ?
            0 :
            nextSelection;

        const skipSelection = finalSelection + ((list[finalSelection].native.type === 'namespace') ? delta : 0);

        const realSelection = (skipSelection < 0) ? list.length - 1 : skipSelection;

        navigateTo('?_' + list[
          realSelection
        ].native.hash);

        ev.preventDefault();
      } else if (ev.key === 't') {
        if (document.activeElement !== this.nativeRefs['search']) {
          this.nativeRefs['search'].focus();

          ev.preventDefault();
        }
      }
    };
  }

  componentDidMount() {
    window.addEventListener('hashchange', this.listener);
    window.addEventListener('popstate', this.stateListener);

    window.addEventListener('keydown', this.keyListener);
  }

  componentWillUnmount() {
    window.removeEventListener('hashchange', this.listener);
    window.removeEventListener('popstate', this.stateListener);

    window.removeEventListener('keydown', this.keyListener);
  }

  addRef = (key, element) => {
    this.nativeRefs[key] = element;
  };

  render() {
    return (
      <App addRef={this.addRef} />
    );
  }
};
